import React, {Component} from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Detail from "./Detail.js"
import Delete from "./Delete.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"

class Responsables extends Component {
    constructor() {
    super();
    this.state = {
       columns: [
            {
                Header: "pk",
                id:"pk",
                accessor: "pk",
                width: 100,
                show: false,
                private: true,
            },
            {
                Header: "Subgrupo",
                id: "subgrupo__padre__nombre",
                accessor: d => d.subgrupo__padre__nombre,
                show: false,
                private: true,
            },
            {
                Header: "Subgrupo",
                id: "subgrupo__nombre",
                accessor: d => d.subgrupo__padre__nombre + " > " + d.subgrupo__nombre,
                show: false,
            },
            {
                Header: "Apellido",
                id: "apellido",
                accessor: d => d.apellido,
                show:true,
            },
            {
                Header: "Nombre",
                id: "nombre",
                accessor: d => d.nombre,
                show:true,
            },
            {
                Header: "Empresa",
                id:"empresa__nombre",
                accessor: "empresa__nombre",
                filterable:true,
                width: 200,
                show:true,
            },
            {
                Header: "Tipo",
                id: "strtipo",
                accessor: d => d.strtipo,
                width: 200,
                show:true,
                Filter: ({ filter, onChange }) =>
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : "TODOS"}
                >
                    <option value="">TODOS</option>
                    <option value="TÉCNICO">TÉCNICO</option>
                    <option value="ADMINISTRATIVO">ADMINISTRATIVO</option>
                </select>
            },
            {
                Header: "Teléfono",
                id:"telefono",
                accessor: "telefono",
                filterable:false,
                width: 100,
                className:"text-right",
                show:true,
            },
            {
                Header: "Email",
                id:"email",
                accessor: "email",
                filterable:false,
                show:true,
            },
        ]
    };
}

render() {
    const { data, pages, loading } = this.state;
    return (
        <ParadigmaTable
        buttons={[
            {
                create:true,
                permission:'responsables_add',
                component:Create,
            },
            {
                edit:true,
                permission:'responsables_detail',
                component:Detail,
            },
            {
                edit:true,
                permission:'responsables_edit',
                component:Edit,
            },
            {
                edit:true,
                permission:'responsables_delete',
                component:Delete,
            }
        ]}
        apiUrl={api.clientes.responsables.list}
        columns={this.state.columns}
        exportUrl={api.clientes.responsables.export}
        title={"Contactos"}
        outerSort={[{"id":"apellido","desc":false}, {"id":"nombre","desc":false}]}
         />
    );
    }
}

export default Responsables;



// WEBPACK FOOTER //
// ./src/views/clientes/Responsables/Responsables.js